module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"local":{"msg":{"loading":"Loading file…"}}},"fr":{"local":{"msg":{"loading":"Ouverture du fichier …"}}}}')
  delete Component.options._Ctor
}
